// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3jhA3","content":"Consent_content__L3Da0","footer":"Consent_footer__2RqJS"};